import { IMessage } from "@home-health-notify/domain";
import { OrganizationContext } from "hhn-commons";
import { useContext } from "react";
import {
  MessageVisibilityIcon,
  MessageVisibilityStatusComponent,
} from "../messageType/MessageContentStyle";

type MessageVisibilityStatusProps = {
  message: IMessage;
};

export const MessageVisibilityStatus = ({
  message,
}: MessageVisibilityStatusProps) => {
  const { selectedOrgUser } = useContext(OrganizationContext);

  let visibilityStatus = "";
  if (message.isVisibleToPatientAndPhysician()) {
    visibilityStatus = "Visible to Patient and Physician";
  } else if (message.isVisibleToPatient()) {
    visibilityStatus = "Visible to Patient";
  } else if (message.isVisibleToPhysician()) {
    visibilityStatus = "Visible to Physician";
  }

  return (
    <>
      {message.isVisibleToPatientOrPhysician() &&
        !selectedOrgUser?.isExternalUser() &&
        !message.isDeleted() && (
          <>
            <MessageVisibilityIcon
              color="secondary"
              fontSize="small"
            ></MessageVisibilityIcon>
            <MessageVisibilityStatusComponent variant="caption">
              {visibilityStatus}
            </MessageVisibilityStatusComponent>
          </>
        )}
    </>
  );
};
